import { render, staticRenderFns } from "./ProductionUpdatesLog.vue?vue&type=template&id=65c20134&scoped=true&"
import script from "./ProductionUpdatesLog.vue?vue&type=script&lang=js&"
export * from "./ProductionUpdatesLog.vue?vue&type=script&lang=js&"
import style0 from "./ProductionUpdatesLog.vue?vue&type=style&index=0&id=65c20134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c20134",
  null
  
)

export default component.exports